import { ItemShownEvent } from '~/shared/event_subjects'
import GtmEmitter from './gtm_emitter'

import GtmEmitterState from './gtm_emitter_state'

// window が unload された状態を表す
export default class TerminatedGtmEmitterState extends GtmEmitterState {
  onEnterState (context: GtmEmitter) {
  }

  onPlaceChanged (context: GtmEmitter, e: ItemShownEvent) {
    // do nothing
  }

  onEnterPage (context: GtmEmitter, pageData: {}) {
    // do nothing
  }

  onEvent (context: GtmEmitter, name: string, data: {} = {}) {
    // do nothing
  }

  terminate (context: GtmEmitter) {
    // do nothing
  }
}
